module.exports = __webpack_public_path__ + "static/media/Covert_Commands_Opening.02093df0.mp3";